import { render, staticRenderFns } from "./unpassCrew.vue?vue&type=template&id=20b13d9c"
import script from "./unpassCrew.vue?vue&type=script&lang=js"
export * from "./unpassCrew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports